import {
  compose,
  css,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { mdBumps } from '../layout'
import { TypoSizeProps, typoSizes } from '../typography'
import { wordBreak, WordBreakProps } from '../typography/wordBreak'

export type ListItemProperty = 'default' | 'bullet'

export interface ListItemProps
  extends LayoutProps,
    SpaceProps,
    WordBreakProps,
    TypoSizeProps {
  variant?: ListItemProperty
}

const defaultProps = withDefaultProps<ListItemProps>({
  variant: 'default',
})

export const ListItem = styled.li.attrs<ListItemProps>(defaultProps)(
  css({
    listStyleType: 'none',
    position: 'relative',
  }),
  variant({
    scale: 'ListItem',
    variants: {
      default: {},
      bullet: {
        pl: mdBumps,
        '&::before': {
          content: '"•"',
          position: 'absolute',
          left: 0,
        },
      },
    },
  }),
  compose(layout, space, wordBreak, typoSizes),
)
